import React, {useState, useEffect} from 'react'
import { toast } from 'react-toastify'
import api from '../../../api/api'

const ListCharge = () => {
  const [chargeList, setChargeList] = useState([])
  const [change, setChange] = useState(true)
 
  useEffect(() => {
    api.get('/services/company/registration/service-charges/')
    .then(response=> {
        // console.log(response.data)
        setChargeList(response.data)
    }).catch(error=> {
      console.log(error)
    })  
  }, [change])
  


  const handleDelete = (id) => {
    api.delete(`/services/company/registration/service-charges/${id}/`)
    .then(response=> {
      setChange(!change)
      toast.success("Service Charges delete")

    }).catch(error=> {
      toast.error("unable to delete")
    })
  }


  return (
    <div className="px-10">
    <div className="text-center text-primary-red text-2xl font-bold my-3">
      Charge List
    </div>
    {/* <input
      placeholder="Search Vat Entry Month "
      type="search"
      className="my-3 rounded-lg border border-black p-3"
    /> */}

    <table className="border-primary-blue min-w-full border text-center">
      <thead className="font-Bree bg-primary-red text-lg font-bold">
        <tr className="">
          <th
            scope="col"
            className="border-primary-blue border-2 px-6 py-4 text-sm font-medium text-white"
          >
            SN.
          </th>
          <th
            scope="col"
            className="border-primary-blue border-2 px-6 py-4 text-sm font-medium text-white"
          >
            Company Type
          </th>
          <th
            scope="col"
            className="border-primary-blue border-2 px-6 py-4 text-sm font-medium text-white"
          >
            Range Start
          </th>
          <th
            scope="col"
            className="border-primary-blue border-2 px-6 py-4 text-sm font-medium text-white"
          >
            Range End
          </th>
          <th
            scope="col"
            className="border-primary-blue border-2 px-6 py-4 text-sm font-medium text-white"
          >
            Amount
          </th>

          <th
            scope="col"
            className="border-primary-blue border-2 px-6 py-4 text-sm font-medium text-white"
          >
            Action
          </th>
         
        </tr>
      </thead>
      <tbody className="font-Acme">
        
        {
          chargeList.map((item, i)=> {
            return (
              <tr className="border-primary-blue border-2 bg-white" key={i}>
              <td className="border-primary-blue whitespace-nowrap border-2 px-6 py-4 text-sm font-light text-gray-900">
                {i+1}
              </td>
              <td className="border-primary-blue whitespace-nowrap border-2 px-6 py-4 text-sm font-light text-gray-900">
               {item.company_type}
              </td>
              <td className="border-primary-blue whitespace-nowrap border-2 px-6 py-4 text-sm font-light text-gray-900">
                {item.range_start}
              </td>
              <td className="border-primary-blue whitespace-nowrap border-2 px-6 py-4 text-sm font-light text-gray-900">
                {item.range_end}
              </td>
              <td className="border-primary-blue whitespace-nowrap border-2 px-6 py-4 text-sm font-light text-gray-900">
                {item.amount}
              </td>
    
              <td className="border-primary-blue whitespace-nowrap rounded-full border-2 py-2 px-4 text-sm">
              
                <button className="bg-primary-blue hover:bg-red-500 rounded-full p-1 px-2 text-white"
                onClick={()=> handleDelete(item.id)}
                >
                  Delete
                </button>
              </td>
          
            </tr> 
            )
          })
        }
      
      </tbody>
    </table>
  </div>
  )
}

export default ListCharge